export default __webpack_public_path__ + "static/media/02.07ccaac1.png";